<template lang="pug">
  .userList
    .row
      .col-md-10.col-md-offset-1
        table.table.table-hover
          thead
            tr
              th
              th
                .input-group
                  input.form-control.input-sm(type='text' v-model='emailFilter' :placeholder='$options.filters.translate("Find in email (min 3 chars)", lang)' @keydown.esc='cancelEmailFilter()')
                  .input-group-addon.input-sm(@click='cancelEmailFilter()' v-tooltip.bottom='$options.filters.translate("Clear filter", lang)')
                    i.fa.fa-xs.fa-times-circle.text-warning(aria-hidden='true')
              th
              th
              th
              th
              th
            tr
              th(style="width: 20%") {{$options.filters.translate('Name', lang)}}
              th(style="width: 25%") {{$options.filters.translate('Email', lang)}}
              th(style="width: 15%") {{$options.filters.translate('Networks', lang)}}
              th(style="width: 10%") {{$options.filters.translate('Roles', lang)}}
              th(style="width: 10%") {{$options.filters.translate('Password', lang)}}
              th(style="width: 10%") {{$options.filters.translate('Active', lang)}}
              th(style="width: 10%") {{$options.filters.translate('Edit', lang)}}
          tbody
            tr.user(v-for='(user, index) in filteredUsers', :key='index')
              td {{user.nick}}
              td {{user.email}}
              td
                span.network(v-for='(network, index) in user.networks', :key='index') {{showNetwork(user.networks, network, index)}}
              td(v-if='user.roles[0]') {{user.roles[0].name}}
              td(v-else)
              td
                div(v-if="!user.azure")
                  button.btn.btn-warning.btn-sm(type="button" @click="resetPass(user.id)" v-tooltip.bottom="$options.filters.translate('Reset password', lang)") Reset
                div(v-else) {{azure(user.azure)}}
              td
                button.btn.btn-success.btn-sm.btn-block(v-if='user.active' @click.prevent='activate(user.id, false)') {{$options.filters.translate('deactivate user', lang)}}
                button.btn.btn-danger.btn-sm.btn-block(v-else @click.prevent='activate(user.id, true)') {{$options.filters.translate('activate user', lang)}}
              td
                button.btn.btn-default.btn-sm.btn-block(@click.prevent='$router.push({name: "userEdit", params: {userId: user.id}})') {{$options.filters.translate('edit', lang)}}
</template>
<script>
export default {
  name: 'userList',
  props: ['lang'],
  data () {
    return {
      networks: this.$store.getters.networks,
      allNetworks: this.$store.getters.allNetworks,
      users: [],
      emailFilter: ''
    }
  },
  computed: {
    filteredUsers () {
      if (this.emailFilter.length > 2) {
        // const search = this.emailFilter.toLowerCase().substr(1)
        return this.users.filter(user => {
          return user.email.toLowerCase().search(this.emailFilter.toLowerCase()) >= 0
        })
      }
      return this.users
    }
  },
  methods: {
    resetPass (id) {
      this.$store.commit('SET_LOADER', true)
      this.$http.post('user/resetPassword', {id})
        .then(response => {
          this.$store.commit('SET_LOADER', false)
          if (response.status === 200) {
            this.$notify(this.$options.filters.translate('New password has been sent', this.lang), 'success')
          } else {
            this.$notify(this.$options.filters.translate('Error', this.lang), 'error')
          }
        })
    },
    cancelEmailFilter () {
      this.emailFilter = ''
    },
    getUsers () {
      this.$http.get(`user?limit=1000`)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.$store.commit('SET_LOADER', false)
          this.users = data
        })
    },
    activate (id, direction) {
      this.$store.commit('SET_LOADER', true)
      this.$http.post('user/activate', {id, direction})
        .then(response => {
          if (response.status === 200) {
            this.$notify(this.$options.filters.translate('User status has been changed', this.lang), 'success')
          } else {
            this.$notify(this.$options.filters.translate('Error', this.lang), 'error')
          }
          this.getUsers()
        })
    },
    showNetwork (userNetworks, id, index) {
      const network = this.allNetworks.find(el => el.id === id)
      return network ? this.withComma(userNetworks, network.name, index) : ''
    },
    azure (val) {
      return (val) ? 'Azure' : ''
    },
    withComma (all, el, index) {
      if (index !== all.length - 1) {
        return `${el}, `
      } else {
        return el
      }
    }
  },
  created () {
    this.getUsers()
  }
}
</script>
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/user/UserList.vue